import {Backbone} from "backboneAdapter";
import i18n from 'l10n';
import ServiceConfiguration from 'js/models/service.config.model';
import {model} from "../adapters/backbone-decorators";
import {delegateEvent} from "../utils/event.delegator";

@model(ServiceConfiguration, {contactIds: [], includedGroups: [], message: ""})
class ServiceSuperView extends Backbone.View {
    constructor(isPostPaid) {
        super();
        this.isPostPaid = isPostPaid;
    }

    async load(id) {
        this.model.set("id", id);
        this.childView = null;
        const model = this.model;
        const data = await this.model.fetch();
        model.changed = model._previousAttributes = {};
        const campaignTemplateType = model.get("campaignTemplateType");

        try {
            const response = await $.ajaxDefaultQ({
                url: `/CampaignCloud/UserInfo/getCompanyNameAndEmail?campaignType=${campaignTemplateType}`,
                type: 'GET'
            });
            if (response.outcome === "OK") {
                model.attributes.email = response.data.email;
                model.attributes.address = response.data.formattedAddress || "";
                model.attributes.subDomain = response.data.subDomain; //used for tellody "commercial" url
                model.attributes.companyNameOrEmail = response.data.companyNameOrEmail || ""; //used on instant wins/sweepstakes/paypalPayments footer text
            }

            this.createChildView(data, model);
        } catch (e) {
            console.error(`Error in retrieving \`companyNameOrEmail\` -> ${e}`);
            this.createChildView(data, model);
        } finally {
            window.addEventListener("beforeunload", e => {
                if (this.childView.trackingUnload && this.model.hasChanged()) {
                    this.model.batchUpdate();
                    const returnValue = i18n.t('generic.confirmleaveconfig');
                    e.returnValue = returnValue;
                    return returnValue;
                } else {
                    return null;
                }
            });
            window.setInterval(() => {
                const $openField = $('.editing').first();
                if ($openField.length)
                    this.model.storeAttribute(
                        this.childView.extractAttr($openField),
                        $($openField.find('form').val()).val()
                    );
                if (this.model.hasChanged()) this.model.batchUpdate();
            }, 10000);
        }
    }

    createChildView(data, model) {
        let View;
        switch (data.campaignTemplateType) {
            case "TELLODY_VOUCHER":
                View = require('js/views/voucher.view').default;
                this.childView = new View(this.isPostPaid, model);
                break;
            case "TELLODY_SURVEY":
            default:
                View = require('js/views/service.view').default;
                this.childView = new View(this.isPostPaid, model);
                this.childView.load().then(() => console.log("loaded service.view"));
                break;
        }

        delegateEvent(this, this.childView, "changed:campaignStatus");
    }
}

export default ServiceSuperView;
